import NavigationLine from "@components/navigation/NavigationLine";
import SHub from "@skeletons/hub/SHub";

import "@styles/hub/MainHub.css";

export default function SMain() {
  return (
    <>
      <NavigationLine />
      <SHub />
    </>
  );
}
